const configurations = {
  visteon: {
    local: {
      api: {
        baseUrl: "http://localhost:3500",
        schedulerUrl: "http://localhost:3600",
        routingUrl: "http://localhost:3700",
      },
    },
    nextdev: {
      api: {
        baseUrl: "https://api.otanextdev.visteoncloud.com",
      },
    }
  },
  hd: {
    dev: {
      api: {
        baseUrl: "https://api.otadev.visteoncloud.com",
      },
    },
    staging: {
      api: {
        baseUrl: "https://api.otastaging.visteoncloud.com",
      },
    },
    prod: {
      api: {
        baseUrl: "https://api.otaprod.visteoncloud.com",
      },
    },
  },
  msil: {
    dev: {
      api: {
        baseUrl: "https://api.msildev.visteoncloud.com",
      },
    },
    staging: {
      api: {
        baseUrl: "https://api.msilstaging.visteoncloud.com",
      },
    },
    prod: {
      api: {
        baseUrl: "https://api.msilprod.visteoncloud.com",
      },
    }
  },
  skoda: {
    staging: {
      api: {
        baseUrl: "https://api.skodastaging.visteoncloud.com",
      },
    },
    prod: {
      api: {
        baseUrl: "https://api.skodaprod.visteoncloud.com",
      },
    }
  }
};

const getConfig = function (customer, stage) {
  if (!configurations[customer][stage]) {
    console.error("No configuration defined for this stage");
    return;
  }
  return configurations[customer][stage];
};

let config = { ...getConfig(process.env.REACT_APP_CUSTOMER_ID, process.env.REACT_APP_STAGE) };

export default config;
